module.exports = __webpack_public_path__ + "29b4a0abfab2baababfc5c3ac28b7b81.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/atom-s.png
// module id = 2574
// module chunks = 0